module.exports = __webpack_public_path__ + "img/lideranca_ouro.faa14b3d.png";